import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { analyticsRoutes } from "~/features/analytics/routes"
import { bolRoutes } from "~/features/bol/routes"
import { bolRequestAvailabilityRoutes } from "~/features/bol-request-availability/routes"
import { baseInformationRoutes } from "~/features/base-information/routes"
import { cargoRoutes } from "~/features/cargo/routes"
import { cargoOwnerRoutes } from "~/features/cargo-owners/routes"
import { contractRoutes } from "~/features/contracts/routes"
import { dashboardRoutes } from "~/features/dashboard/routes"
import { driverRoutes } from "~/features/drivers/routes"
import { driverMessageRoutes } from "~/features/driver-messages/routes"
import { driverBirthdayRoutes } from "~/features/driver-birthdays/routes"
import { driverDocumentExpiryRoutes } from "~/features/driver-document-expiry/routes"
import { financeRoutes } from "~/features/finance/routes"
import { loadingRoutes } from "~/features/loading/routes"
import { issuingSystemSettingsRoutes } from "~/features/issuing-system-settings/routes"
import { mobileBannerRoutes } from "~/features/mobile-banners/routes"
import { mobileConfigRoutes } from "~/features/mobile-config/routes"
import { notificationCampaignRoutes } from "~/features/notification-campaigns/routes"
import { notificationRoutes } from "~/features/notifications/routes"
import { otherConfigRoutes } from "~/features/other-configs/routes"
import { distributionRulesRoutes } from "~/features/distribution-rules/routes"
import { otpRoutes } from "~/features/otp/routes"
import { pickupBolRoutes } from "~/features/pickup-bol/routes"
import { pricingSettingsRoutes } from "~/features/pricing-settings/routes"
import ProtectedRoutes from "./ProtectedRoutes"

const MainLayout = loadable(
  async () => import("~/layout/main-layout/MainLayout"),
  {
    fallback: <></>,
  },
)

const HeaderOnlyLayout = loadable(
  async () => import("~/layout/header-only-layout/HeaderOnlyLayout"),
  {
    fallback: <></>,
  },
)

const BolPlaygroundPage = loadable(
  async () => import("~/features/bol-playground/BolPlaygroundPage"),
  {
    fallback: <></>,
  },
)

const JobMonitoringPage = loadable(
  async () => import("~/features/job-monitoring/JobMonitoringPage"),
  { fallback: <></> },
)

export const mainRoutes: RouteObject[] = [
  {
    element: <ProtectedRoutes />,
    children: [
      {
        path: "/monitoring/jobs",
        element: <JobMonitoringPage />,
      },
      {
        element: <HeaderOnlyLayout />,
        children: [
          {
            path: "/bol-management/hagbar-playground/:BOLId?",
            element: <BolPlaygroundPage />,
          },
        ],
      },
      {
        element: <MainLayout />,
        children: [
          ...dashboardRoutes,
          ...analyticsRoutes,
          ...baseInformationRoutes,
          ...cargoRoutes,
          ...cargoOwnerRoutes,
          ...driverRoutes,
          ...driverMessageRoutes,
          ...driverBirthdayRoutes,
          ...driverDocumentExpiryRoutes,
          ...bolRoutes,
          ...bolRequestAvailabilityRoutes,
          ...issuingSystemSettingsRoutes,
          ...contractRoutes,
          ...financeRoutes,
          ...otpRoutes,
          ...loadingRoutes,
          ...mobileBannerRoutes,
          ...mobileConfigRoutes,
          ...notificationCampaignRoutes,
          ...otherConfigRoutes,
          ...distributionRulesRoutes,
          ...pickupBolRoutes,
          ...pricingSettingsRoutes,
          ...notificationRoutes,
        ],
      },
    ],
  },
]
